import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

import { UserGuard } from '@/modules/UserGuard';
import { UserStatus } from '@/modules/api';
import { useUserQuery } from '@/queries/useUserQuery';

function BackendLayout() {
  const { data: user, isLoading } = useUserQuery();

  if (isLoading) return null;

  if (UserGuard.isUser(user) && user.status === UserStatus.ACTIVE) return <Outlet />;

  return <Navigate to="/registrierung" />;
}

export const Route = createFileRoute('/_authenticated/_management')({
  component: BackendLayout,
});
